import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types'
import '../../ReassignQueuePage.scss'
import HrbTranslate from '../../../../components/language/HrbTranslate';
import { SortTypes } from '../../../offices/enums/SortTypes';
import EmployeesQueueHeaderSortLink from '../../../offices/components/EmployeesQueueHeaderSortLink';

const ReassignAssociateTableColumnHeader = ({ queue, sort, onSortChanged, reversed }) => {

    const handleSort = (sortValue, reversed) => {
        onSortChanged(sortValue, reversed)
    }

    return (
        <div className='columns reassign-associate-table-header'>
            <div className='column is-1 reassign-associate-radio-button-wrapper'></div>
            <div className='column is-2'>
                <EmployeesQueueHeaderSortLink sort={sort} sortValue={SortTypes.CLIENT_NAME} reversed={reversed} onSortChanged={handleSort}>
                    <HrbTranslate text='QueuePage.Labels.ReassignAssociateAssignee' />
                </EmployeesQueueHeaderSortLink>
            </div>
            <div className='column is-3'>
                <EmployeesQueueHeaderSortLink sort={sort} sortValue={SortTypes.ROLE} reversed={reversed} onSortChanged={handleSort}>
                    <HrbTranslate text='QueuePage.Labels.ReassignAssociateRole' />
                </EmployeesQueueHeaderSortLink>
            </div>
            <div className='column is-2'>
                <EmployeesQueueHeaderSortLink sort={sort} sortValue={SortTypes.NEW} reversed={reversed} onSortChanged={handleSort}>
                    <HrbTranslate text='QueuePage.Labels.ReassignAssociateNew' />
                </EmployeesQueueHeaderSortLink>
            </div>
            <div className='column is-2'>
                <EmployeesQueueHeaderSortLink sort={sort} sortValue={SortTypes.IN_PROGRESS} reversed={reversed} onSortChanged={handleSort}>
                    <HrbTranslate text='QueuePage.Labels.ReassignAssociateInProgress' />
                </EmployeesQueueHeaderSortLink>
            </div>
            <div className='column is-2'>
                <EmployeesQueueHeaderSortLink sort={sort} sortValue={SortTypes.AVG_COMPLETION} reversed={reversed} onSortChanged={handleSort}>
                    <HrbTranslate text='QueuePage.Labels.ReassignAssociateAvgCompletion' />
                </EmployeesQueueHeaderSortLink>
            </div>
            
        </div>
    );
}

export default ReassignAssociateTableColumnHeader